"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
var _methods; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'couponEAct',
  components: {},
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  watch: {},
  emits: ['addAct', 'handleEdit', 'detailUser'],
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      officers: [],
      searchForm: {
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      currentOfficerId: null,
      // 添加黑名单弹窗相关（使用 keywords 字段）
      addDialogVisible: false,
      addForm: {
        keywords: '',
        blackTimeStr: ''
      },
      members: [],
      memberLoading: false,
      memberSearch: {
        page: 1,
        limit: 10,
        total: 0
      },
      selectedMemberId: null
    };
  },
  computed: {},
  methods: (_methods = {
    addBlacklist: function addBlacklist() {},
    changeTime: function changeTime(e) {
      console.log(e);
      if (!e || e == '') {
        this.searchForm.month = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.month = e;
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      _redbook.default.getBlackList(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          var date = new Date(item.createTime);
          var date2 = new Date(item.blackTime);
          var year = date.getFullYear();
          var month = _this.pad(date.getMonth() + 1);
          var day = _this.pad(date.getDate());
          var hours = _this.pad(date.getHours());
          var mins = _this.pad(date.getMinutes());
          var secs = _this.pad(date.getSeconds());
          item.createTime = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
          var year2 = date2.getFullYear();
          var month2 = _this.pad(date2.getMonth() + 1);
          var day2 = _this.pad(date2.getDate());
          var hours2 = _this.pad(date2.getHours());
          var mins2 = _this.pad(date2.getMinutes());
          var secs2 = _this.pad(date2.getSeconds());
          item.blackTime = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
        });
        _this.tableData = res.records || [];
        _this.searchForm.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    openRewardDialog: function openRewardDialog(row) {
      // 尝试从行数据或搜索表单中找到 officerId，回退到 row.id
      this.currentOfficerId = row.officerId || this.searchForm.officerId || row.id;
      this.rewardSearch.page = 1;
      this.rewardDialogVisible = true;
      this.fetchRewardList();
    },
    fetchRewardList: function fetchRewardList() {
      var _this2 = this;
      if (!this.currentOfficerId) return;
      this.rewardLoading = true;
      var params = {
        page: this.rewardSearch.page,
        limit: this.rewardSearch.limit,
        officerId: this.currentOfficerId
      };
      _redbook.default.officerRewardLog(params).then(function (res) {
        var records = res.records || [];
        records.forEach(function (item) {
          if (item.createTime) {
            try {
              var date = new Date(item.createTime);
              var y = date.getFullYear();
              var m = _this2.pad(date.getMonth() + 1);
              var d = _this2.pad(date.getDate());
              var hh = _this2.pad(date.getHours());
              var mm = _this2.pad(date.getMinutes());
              var ss = _this2.pad(date.getSeconds());
              item.createTime = "".concat(y, "-").concat(m, "-").concat(d, " ").concat(hh, ":").concat(mm, ":").concat(ss);
            } catch (e) {}
          }
        });
        _this2.rewardList = records;
        _this2.rewardSearch.total = res.total || 0;
      }).finally(function () {
        _this2.rewardLoading = false;
      });
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "addBlacklist", function addBlacklist() {
    this.addForm.keywords = '';
    this.addForm.blackTimeStr = '';
    this.members = [];
    this.selectedMemberId = null;
    this.memberSearch.page = 1;
    this.memberSearch.total = 0;
    this.addDialogVisible = true;
  }), "searchMember", function searchMember() {
    var _this3 = this;
    var kw = (this.addForm.keywords || '').toString().trim();
    if (!kw) {
      this.$message.warning('请输入手机号或卡号搜索');
      return;
    }
    var params = {
      page: this.memberSearch.page,
      limit: this.memberSearch.limit,
      keywords: kw
    };
    this.memberLoading = true;
    _redbook.default.queryMember(params).then(function (res) {
      var records = res.records || [];
      _this3.members = records;
      _this3.memberSearch.total = res.total || 0;
    }).catch(function () {
      _this3.members = [];
      _this3.memberSearch.total = 0;
    }).finally(function () {
      _this3.memberLoading = false;
    });
  }), "selectMember", function selectMember(row) {
    this.selectedMemberId = row.userId;
  }), "rowClassName", function rowClassName(_ref) {
    var row = _ref.row;
    return this.selectedMemberId === row.userId ? 'current-row' : '';
  }), "handleMembersPageChange", function handleMembersPageChange(newPage) {
    this.memberSearch.page = newPage;
    this.searchMember();
  }), "handleMembersSizeChange", function handleMembersSizeChange(newSize) {
    this.memberSearch.limit = newSize;
    this.memberSearch.page = 1;
    this.searchMember();
  }), "submitAdd", function submitAdd() {
    var _this4 = this;
    if (!this.selectedMemberId) {
      this.$message.warning('请选择一个会员');
      return;
    }
    if (!this.addForm.blackTimeStr) {
      this.$message.warning('请选择黑名单截止日期');
      return;
    }
    var member = this.members.find(function (m) {
      return m.userId === _this4.selectedMemberId;
    }) || {};
    var payload = {
      userId: member.userId,
      blackTimeStr: this.addForm.blackTimeStr
    };
    this.memberLoading = true;
    _redbook.default.setBlackList(payload).then(function () {
      _this4.$message.success('加入黑名单成功');
      _this4.addDialogVisible = false;
      _this4.fetchList();
    }).catch(function () {
      _this4.$message.error('加入黑名单失败');
    }).finally(function () {
      _this4.memberLoading = false;
    });
  }), "formatDate", function formatDate(d) {
    var date = new Date(d);
    var y = date.getFullYear();
    var m = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    return "".concat(y, "-").concat(m, "-").concat(day);
  }), "handleRewardSizeChange", function handleRewardSizeChange(newSize) {
    this.rewardSearch.limit = newSize;
    this.rewardSearch.page = 1;
    this.fetchRewardList();
  }), "handleRewardPageChange", function handleRewardPageChange(newPage) {
    this.rewardSearch.page = newPage;
    this.fetchRewardList();
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "download", function download() {}), "handleSizeChange", function handleSizeChange(newSize) {
    this.searchForm.limit = newSize;
    this.searchForm.page = 1;
    this.fetchList();
  }), "handlePageChange", function handlePageChange(newPage) {
    this.searchForm.page = newPage;
    this.fetchList();
  }), "getOfficers", function getOfficers() {
    var _this5 = this;
    var data = {
      page: 1,
      limit: 99999
    };
    _redbook.default.getofficer(data).then(function (res) {
      _this5.officers = res.records || [];
      if (res.records[0] && (_this5.userId == 'null' || _this5.userId == 0)) {
        _this5.searchForm.officerId = res.records[0].id;
        _this5.fetchList();
      } else {
        _this5.fetchList();
      }
    });
  }), "handleDelete", function handleDelete(row) {
    var _this6 = this;
    this.$confirm('确定将该卡号从黑名单移除吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _this6.loading = true;
      _redbook.default.delBlackList({
        id: row.id
      }).then(function (res) {
        _this6.$message.success('移除成功');
        _this6.fetchList();
      }).catch(function (err) {
        _this6.$message.error('移除失败');
      }).finally(function () {
        _this6.loading = false;
      });
    }).catch(function () {});
  })),
  mounted: function mounted() {
    this.fetchList();
  }
};